// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Data from "common/src/data/Data.bs.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as UnitName0 from "common/src/tft-static/UnitName0.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as AugmentImage from "common/src/tft-static/AugmentImage.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as RitoDescription from "common/src/components/RitoDescription.bs.js";
import * as RitoDescription2 from "common/src/components/RitoDescription2.bs.js";
import * as InfoSectionHeader from "./InfoSectionHeader.bs.js";

var augmentsGrid = "grid gap-6 pb-16 grid-cols-[repeat(1,328px)] sm:grid-cols-[repeat(2,292px)] md:grid-cols-[repeat(3,280px)]";

var Styles = {
  augmentsGrid: augmentsGrid
};

var stageLabels = [
  "2-1",
  "3-2",
  "4-2"
];

function AugmentsInfoPage$Cell(Props) {
  var id = Props.id;
  var info = Props.info;
  TftSet.use(undefined);
  var t = Translation.useT(/* Augments */4);
  var desc = t(id + "_desc");
  var picks = info.picks;
  return React.createElement(ContentSection.make, {
              children: React.createElement("div", undefined, React.createElement("h4", {
                        className: "font-semibold pb-1 font-montserrat text-lg"
                      }, t(id)), React.createElement("div", {
                        className: "flex items-start"
                      }, React.createElement("div", {
                            className: "flex-shrink-0 pr-2",
                            id: id
                          }, React.createElement(AugmentImage.make, {
                                augId: id,
                                size: 42
                              })), React.createElement("div", {
                            className: "text-sm leading-snug"
                          }, React.createElement(RitoDescription2.make, {
                                desc: desc
                              }))), picks !== undefined ? React.createElement("div", {
                          className: "flex gap-[10px] mt-3"
                        }, Belt_Array.mapWithIndex(stageLabels, (function (idx, label) {
                                return React.createElement("div", {
                                            key: String(idx),
                                            className: "px-2 py-[6px] rounded bg-bg2 " + (
                                              Caml_obj.caml_equal(Belt_Array.get(picks, idx), false) ? "opacity-30" : ""
                                            )
                                          }, label);
                              }))) : null)
            });
}

var Cell = {
  make: AugmentsInfoPage$Cell
};

function AugmentsInfoPage$HeroAugmentsGrid(Props) {
  var heroAugments = Props.heroAugments;
  var set = TftSet.use(undefined);
  var t = Translation.useT(/* Augments */4);
  return React.createElement("div", {
              className: "flex flex-col max-w-[888px]"
            }, Belt_Array.mapWithIndex(Sd.allUnits(set), (function (idx, unitId) {
                    return React.createElement("div", {
                                className: "flex flex-col sm:flex-row gap-2 sm:gap-6 p-4" + (
                                  idx % 2 === 0 ? " bg-bg2" : ""
                                )
                              }, React.createElement("div", {
                                    className: "w-[72px] flex-shrink-0 flex flex-row sm:flex-col items-center pt-1 gap-[6px] text-center"
                                  }, React.createElement(UnitImage.make, {
                                        unitId: unitId,
                                        size: 44,
                                        sizeSm: 52
                                      }), React.createElement(UnitName0.make, {
                                        unit: unitId
                                      })), React.createElement("div", {
                                    className: "flex gap-6"
                                  }, Belt_Array.map(Belt_SortArray.stableSortBy(Belt_Array.keep(heroAugments, (function (param) {
                                                  return Belt_Option.getExn(param[1].hero)[0] === unitId;
                                                })), (function (param, param$1) {
                                              return Caml.caml_string_compare(Belt_Option.getExn(param[1].hero)[1], Belt_Option.getExn(param$1[1].hero)[1]);
                                            })), (function (param) {
                                          var id = param[0];
                                          var desc = t(id + "_desc");
                                          var parts = RitoDescription.parse(Data.replaceAugmentVariables(undefined, desc, id, set));
                                          Belt_Option.getExn(param[1].hero);
                                          return React.createElement("div", {
                                                      className: "flex-1"
                                                    }, React.createElement("h4", {
                                                          className: "font-semibold pb-1 font-montserrat text-base sm:text-lg leading-snug"
                                                        }, t(id)), React.createElement("div", {
                                                          className: "text-sm leading-snug"
                                                        }, React.createElement(RitoDescription.make, {
                                                              parts: parts
                                                            })));
                                        }))));
                  })));
}

var HeroAugmentsGrid = {
  make: AugmentsInfoPage$HeroAugmentsGrid
};

function AugmentsInfoPage(Props) {
  var set = Props.set;
  var t = Translation.useT(/* Common */0);
  var baseData = React.useMemo((function () {
          return Belt_Array.map(Belt_Array.keep(Belt_SortArray.stableSortBy(Js_dict.entries(Data.augments(set)), (function (param, param$1) {
                                return Caml.caml_string_compare(param[1].name, param$1[1].name);
                              })), (function (param) {
                            var augment = param[1];
                            if (Belt_Option.isNone(augment.hero)) {
                              return Belt_Option.isNone(augment.typ);
                            } else {
                              return false;
                            }
                          })), (function (param) {
                        return [
                                param[0],
                                param[1]
                              ];
                      }));
        }), []);
  var bmData = React.useMemo((function () {
          return Belt_Array.map(Belt_Array.keep(Belt_SortArray.stableSortBy(Js_dict.entries(Data.augments(set)), (function (param, param$1) {
                                return Caml.caml_string_compare(param[1].name, param$1[1].name);
                              })), (function (param) {
                            var augment = param[1];
                            if (Belt_Option.isNone(augment.hero)) {
                              return Caml_obj.caml_equal(augment.typ, "bm");
                            } else {
                              return false;
                            }
                          })), (function (param) {
                        return [
                                param[0],
                                param[1]
                              ];
                      }));
        }), []);
  var match = React.useState(function () {
        return 0;
      });
  var tab = match[0];
  return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(TftSet.fromNum(set), React.createElement(AdLayout.make, {
                      children: React.createElement("div", {
                            className: "flex flex-col items-center" + (
                              tab === 0 ? " px-4" : ""
                            )
                          }, tab !== 0 ? null : React.createElement(React.Fragment, undefined, React.createElement(InfoSectionHeader.make, {
                                      title: t("Silver")
                                    }), React.createElement("div", {
                                      className: augmentsGrid
                                    }, Belt_Array.map(Belt_Array.keep(baseData, (function (param) {
                                                return param[1].rank === 1;
                                              })), (function (param) {
                                            var id = param[0];
                                            return React.createElement(AugmentsInfoPage$Cell, {
                                                        id: id,
                                                        info: param[1],
                                                        key: id
                                                      });
                                          }))), React.createElement(InfoSectionHeader.make, {
                                      title: t("Gold")
                                    }), React.createElement("div", {
                                      className: augmentsGrid
                                    }, Belt_Array.map(Belt_Array.keep(baseData, (function (param) {
                                                return param[1].rank === 2;
                                              })), (function (param) {
                                            var id = param[0];
                                            return React.createElement(AugmentsInfoPage$Cell, {
                                                        id: id,
                                                        info: param[1],
                                                        key: id
                                                      });
                                          }))), React.createElement(InfoSectionHeader.make, {
                                      title: t("Prismatic")
                                    }), React.createElement("div", {
                                      className: augmentsGrid
                                    }, Belt_Array.map(Belt_Array.keep(baseData, (function (param) {
                                                return param[1].rank === 3;
                                              })), (function (param) {
                                            var id = param[0];
                                            return React.createElement(AugmentsInfoPage$Cell, {
                                                        id: id,
                                                        info: param[1],
                                                        key: id
                                                      });
                                          }))), React.createElement(InfoSectionHeader.make, {
                                      title: t("Black Market")
                                    }), React.createElement("div", {
                                      className: augmentsGrid
                                    }, Belt_Array.map(bmData, (function (param) {
                                            var id = param[0];
                                            return React.createElement(AugmentsInfoPage$Cell, {
                                                        id: id,
                                                        info: param[1],
                                                        key: id
                                                      });
                                          })))))
                    }), undefined));
}

var make = AugmentsInfoPage;

export {
  Styles ,
  stageLabels ,
  Cell ,
  HeroAugmentsGrid ,
  make ,
  
}
/* Sd Not a pure module */
